
import { Copy, ExternalLink } from "lucide-react";
import { Button } from "../ui/button";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";

interface SocialShareProps {
  content: string;
  title?: string;
  url?: string;
  showCopyButton?: boolean;
  showViewButton?: boolean;
  buttonVariant?: "default" | "destructive" | "outline" | "secondary" | "ghost" | "link";
  className?: string;
}

/**
 * A reusable component for copying content to clipboard or viewing in a dedicated page
 */
const SocialShare = ({
  content,
  title = "Custom Fortune Message",
  url = window.location.href,
  showCopyButton = true,
  showViewButton = true,
  buttonVariant = "outline",
  className,
}: SocialShareProps) => {
  const navigate = useNavigate();

  const copyToClipboard = () => {
    navigator.clipboard.writeText(content);
    toast.success("Content copied to clipboard!");
  };

  const openInNewPage = () => {
    // Encode the fortune message to handle special characters properly
    const encodedMessage = encodeURIComponent(content);
    navigate(`/view-fortune?message=${encodedMessage}`);
  };

  return (
    <div className={`flex flex-wrap ${className ?? "justify-center gap-3"}`}>
      {showCopyButton && (
        <Button
          variant={buttonVariant}
          className="flex items-center gap-2"
          onClick={copyToClipboard}
        >
          <Copy size={16} />
          Copy
        </Button>
      )}
      {showViewButton && (
        <Button
          variant={buttonVariant}
          className="flex items-center gap-2"
          onClick={openInNewPage}
        >
          <ExternalLink size={16} />
          Share
        </Button>
      )}
    </div>
  );
};

export default SocialShare;
